$( document ).ready( function() {
  w_products.init();
  w_modal.init();
} );
